import { render, staticRenderFns } from "./business-order-pane.vue?vue&type=template&id=53cc724d&scoped=true"
import script from "./business-order-pane.vue?vue&type=script&lang=ts"
export * from "./business-order-pane.vue?vue&type=script&lang=ts"
import style0 from "./business-order-pane.vue?vue&type=style&index=0&id=53cc724d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc724d",
  null
  
)

export default component.exports